import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection: React.FC = () => {
  return (
    <div className="container-fluid about py-5">
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          <div className="col-lg-7 wow fadeInLeft" data-wow-delay="0.2s">
            <div className="h-100">
              <h4 className="text-primary">About WiZiAi</h4>
              <h1 className="display-4 mb-4">
                Revolutionizing <strong style={{ color: "#667eea" }}>JEE & NEET Preparation</strong> with AI
              </h1>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <span className="fas fa-robot fa-3x me-3 text-primary"></span>
                    <h5 className="mb-0">AI-Powered Learning</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <span className="fas fa-chart-line fa-3x me-3 text-primary"></span>
                    <h5 className="mb-0">Smart Gap Analysis</h5>
                  </div>
                </div>
              </div>
              <p className="mb-4">
                WiZiAi is India's most advanced AI-powered learning platform designed specifically for JEE and NEET aspirants. 
                Our mission is to democratize high-quality exam preparation by making personalized, intelligent tutoring 
                accessible to every student, regardless of their location or economic background.
              </p>
              <p className="mb-4">
                Built on cutting-edge artificial intelligence, WiZiAi understands each student's unique learning patterns, 
                identifies knowledge gaps in real-time, and creates personalized study paths that adapt as you progress. 
                Our voice-enabled AI tutor provides instant doubt clarification, making learning as natural as having 
                a conversation with your best teacher.
              </p>
              <p className="mb-4">
                We believe that every student deserves access to world-class education. That's why WiZiAi combines the 
                expertise of top educators with the power of AI to deliver personalized learning experiences that were 
                once available only to a privileged few.
              </p>
              <div className="text-dark mb-4">
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Personalized AI-driven test sequences based on your learning style
                </p>
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Real-time performance tracking and intelligent gap analysis
                </p>
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Voice-enabled AI tutor for instant doubt clarification
                </p>
                <p className="fs-5">
                  <span className="fa fa-check text-primary me-2"></span>
                  Adaptive learning paths that evolve with your progress
                </p>
              </div>
              <div className="wiziai-about-cta">
                <Link 
                  to="/about" 
                  className="btn btn-primary py-3 px-5 me-3"
                >
                  Learn More About Us
                </Link>
                <Link 
                  to="/demo" 
                  className="btn btn-outline-primary py-3 px-5"
                >
                  Try Demo
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5 wow fadeInRight" data-wow-delay="0.2s">
            <div className="position-relative h-100">
              <div className="wiziai-about-visual">
                <div className="wiziai-ai-illustration">
                  <div className="wiziai-brain-icon">
                    <i className="fas fa-brain fa-5x text-primary"></i>
                  </div>
                  <div className="wiziai-connection-lines">
                    <svg className="wiziai-connection-svg" viewBox="0 0 400 400">
                      {/* Animated lines from center to each node */}
                      <line x1="200" y1="200" x2="70" y2="80" stroke="#667eea" strokeWidth="2" strokeDasharray="8,4" className="wiziai-line wiziai-line-1">
                        <animate attributeName="stroke-dashoffset" values="0;24;0" dur="3s" repeatCount="indefinite"/>
                      </line>
                      <line x1="200" y1="200" x2="330" y2="90" stroke="#667eea" strokeWidth="2" strokeDasharray="8,4" className="wiziai-line wiziai-line-2">
                        <animate attributeName="stroke-dashoffset" values="0;24;0" dur="3s" begin="0.5s" repeatCount="indefinite"/>
                      </line>
                      <line x1="200" y1="200" x2="50" y2="300" stroke="#667eea" strokeWidth="2" strokeDasharray="8,4" className="wiziai-line wiziai-line-3">
                        <animate attributeName="stroke-dashoffset" values="0;24;0" dur="3s" begin="1s" repeatCount="indefinite"/>
                      </line>
                      <line x1="200" y1="200" x2="350" y2="320" stroke="#667eea" strokeWidth="2" strokeDasharray="8,4" className="wiziai-line wiziai-line-4">
                        <animate attributeName="stroke-dashoffset" values="0;24;0" dur="3s" begin="1.5s" repeatCount="indefinite"/>
                      </line>
                      
                      {/* Animated dots moving along lines */}
                      <circle r="4" fill="#ffd700" className="wiziai-dot wiziai-dot-1">
                        <animateMotion dur="4s" repeatCount="indefinite">
                          <path d="M200,200 L70,80"/>
                        </animateMotion>
                      </circle>
                      <circle r="4" fill="#ffd700" className="wiziai-dot wiziai-dot-2">
                        <animateMotion dur="4s" begin="1s" repeatCount="indefinite">
                          <path d="M200,200 L330,90"/>
                        </animateMotion>
                      </circle>
                      <circle r="4" fill="#ffd700" className="wiziai-dot wiziai-dot-3">
                        <animateMotion dur="4s" begin="2s" repeatCount="indefinite">
                          <path d="M200,200 L50,300"/>
                        </animateMotion>
                      </circle>
                      <circle r="4" fill="#ffd700" className="wiziai-dot wiziai-dot-4">
                        <animateMotion dur="4s" begin="3s" repeatCount="indefinite">
                          <path d="M200,200 L350,320"/>
                        </animateMotion>
                      </circle>
                      
                      {/* Central pulse circle */}
                      <circle cx="200" cy="200" r="25" fill="none" stroke="#667eea" strokeWidth="1" opacity="0.5">
                        <animate attributeName="r" values="25;40;25" dur="2s" repeatCount="indefinite"/>
                        <animate attributeName="opacity" values="0.5;0.1;0.5" dur="2s" repeatCount="indefinite"/>
                      </circle>
                    </svg>
                    
                    <div className="wiziai-node wiziai-node-1">
                      <i className="fas fa-microphone"></i>
                      <span>Voice AI</span>
                    </div>
                    <div className="wiziai-node wiziai-node-2">
                      <i className="fas fa-chart-bar"></i>
                      <span>Analytics</span>
                    </div>
                    <div className="wiziai-node wiziai-node-3">
                      <i className="fas fa-graduation-cap"></i>
                      <span>Learning</span>
                    </div>
                    <div className="wiziai-node wiziai-node-4">
                      <i className="fas fa-clipboard-check"></i>
                      <span>Testing</span>
                    </div>
                  </div>
                </div>
                <div className="wiziai-stats-card">
                  <div className="bg-primary p-4 rounded">
                    <h4 className="display-3 mb-0 text-white">50K+</h4>
                    <p className="text-white fs-5 mb-0">Students Empowered</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
